import { render, staticRenderFns } from "./couponForm.vue?vue&type=template&id=4278daa0&scoped=true&"
import script from "./couponForm.vue?vue&type=script&lang=js&"
export * from "./couponForm.vue?vue&type=script&lang=js&"
import style0 from "./couponForm.vue?vue&type=style&index=0&id=4278daa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4278daa0",
  null
  
)

export default component.exports